// extracted by mini-css-extract-plugin
export default {"container":"JobCount_container__ssS6t","heading":"JobCount_heading__TMzQN","statCard":"JobCount_statCard__iEAII","statsTable":"JobCount_statsTable__UtKJb"};